import { render } from "./ThemedicUpdate.vue?vue&type=template&id=3646bb24&scoped=true"
import script from "./ThemedicUpdate.vue?vue&type=script&lang=js"
export * from "./ThemedicUpdate.vue?vue&type=script&lang=js"

import "./ThemedicUpdate.vue?vue&type=style&index=0&id=3646bb24&lang=scss&scoped=true"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3646bb24"]])

export default __exports__